
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { useEffect } from "react";

interface PaymentButtonProps {
  onSubmit: () => void;
  disabled: boolean;
  loading: boolean;
  buttonText?: string;
}

const PaymentButton = ({ onSubmit, disabled, loading, buttonText = "Lõpeta makse" }: PaymentButtonProps) => {
  // Log initial render props for debugging
  useEffect(() => {
    console.log("PaymentButton initial props:", { disabled, loading, buttonText });
  }, []);
  
  // Log re-renders with changed props
  useEffect(() => {
    console.log("PaymentButton props updated:", { disabled, loading });
  }, [disabled, loading]);
  
  const handleClick = (e: React.MouseEvent) => {
    // Log every click attempt
    console.log("💥 PaymentButton: Nuppu klikiti!", { disabled, loading });
    
    // Prevent default browser behavior
    e.preventDefault();
    
    // Stop event propagation to prevent any parent handlers from capturing it
    e.stopPropagation();
    
    if (!disabled && !loading) {
      console.log("💥 PaymentButton: Käivitan onSubmit callback'i");
      onSubmit();
    } else {
      console.log("💥 PaymentButton: Nupp on keelatud või laadimas - ei kutsu onSubmit", { disabled, loading });
    }
  };

  return (
    <Button 
      onClick={handleClick}
      className="w-full bg-gray-900 hover:bg-gray-800 text-white py-6 text-lg transition-all cursor-pointer"
      disabled={disabled || loading}
      type="button"
      style={{ 
        pointerEvents: 'auto',
        position: 'relative',
        zIndex: 100
      }}
    >
      {loading ? (
        <span className="flex items-center justify-center">
          <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          Töötlen...
        </span>
      ) : (
        <span className="pointer-events-none">{buttonText}</span>
      )}
    </Button>
  );
};

export default PaymentButton;
